// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 16px;
  min-width: 16px;
  padding: 0 5px;
  border: var(--admin-border-default);
  border-radius: var(--admin-radius-sm);
  background: var(--admin-bg-sunken);
  color: var(--admin-text-secondary);
  font-family: 'SFMono-Regular', SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: var(--admin-text-micro);
  font-weight: var(--admin-font-weight-semibold);
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminKbd.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,4FAA4F;EAC5F,kCAAkC;EAClC,8CAA8C;EAC9C,cAAc;AAChB","sourcesContent":[".au-kbd {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 16px;\n  min-width: 16px;\n  padding: 0 5px;\n  border: var(--admin-border-default);\n  border-radius: var(--admin-radius-sm);\n  background: var(--admin-bg-sunken);\n  color: var(--admin-text-secondary);\n  font-family: 'SFMono-Regular', SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;\n  font-size: var(--admin-text-micro);\n  font-weight: var(--admin-font-weight-semibold);\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
